// extracted by mini-css-extract-plugin
export default {"container":"queueCounter_container__zgnA8","imageContainer":"queueCounter_imageContainer__K4JmO","clientsNum":"queueCounter_clientsNum__Vk+OP","info":"queueCounter_info__7cMxp"};